import React from "react";
import PropTypes from "prop-types";
import "./withdraw_tax_description.scss";

export const WithdrawTaxDesciption = ({ tax, limit }) => {
	return (
		<div className="withdraw-tax-desc">
			{`Your total money prize for this year has exceeded ${limit} EUR. According to the law we must pay income tax ${tax} % on amounts exceeding ${limit} EUR. So you will receive the money less ${tax} % tax.`}
		</div>
	);
};

WithdrawTaxDesciption.propTypes = {
	tax: PropTypes.number,
	limit: PropTypes.number,
};
